import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="flex min-h-screen w-full bg-background-50">
      <div className="relative hidden w-1/2 lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20study%20desk%20scene%20with%20open%20notebooks%2C%20pencils%20and%20a%20cup%20of%20tea%2C%20soft%20natural%20window%20light%2C%20calm%20beige%20and%20sage%20green%20tones%2C%20artistic%20editorial%20composition%2C%20gentle%20shadows%2C%20quiet%20academic%20atmosphere&width=1000&height=1200&seq=auth-study-warm-01&orientation=portrait"
          alt="따뜻한 분위기의 공부 책상"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/25 to-black/10"></div>
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-marked-line text-xl"></i>
          </span>
          <h2 className="text-3xl font-bold leading-snug text-white">
            학생 한 명 한 명의
            <br />
            성장을 기록하다
          </h2>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-white/80">
            진도, 수업일지, 시험 결과, 교습비까지 한 곳에서 관리하고
            학부모님께도 투명하게 공유하세요.
          </p>
        </div>
      </div>

      <div className="flex w-full flex-col justify-center px-6 py-12 lg:w-1/2 lg:px-16">
        <div className="mx-auto w-full max-w-md">
          <Link to="/login" className="mb-10 flex items-center gap-2 lg:hidden">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-marked-line text-lg"></i>
            </span>
            <span className="text-base font-bold text-foreground-950">과외매니저</span>
          </Link>

          <h1 className="text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h1>
          <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>

          <div className="mt-8">{children}</div>

          {footer && <div className="mt-6">{footer}</div>}
        </div>
      </div>
    </div>
  );
}